<template>
  <div class="overflow-hidden text-left select-none flex flex-wrap gap-1.5" :style="{ '--duration': '200ms' }">
    <TransitionGroup name="list">
      <div
        class="py-1.5 px-3 min-w-12 justify-center rounded-full border border-charcoal-200 dark:border-dark-600 flex items-center font-bold text-sm shrink-0 transition cursor-pointer"
        :class="[
          !modelValue.includes(option.value) && modelValue.length > 0 ? 'bg-charcoal-200 dark:bg-dark-800 dark:text-dark-300' : 'bg-white dark:bg-dark-600 dark:text-dark-50'
        ]"
        @click="() => onSelect(option)"
        v-for="option in optionsVisible"
        :key="option.value"
      >
        <ImageEmoji :name="option.image" class="size-5 mr-2" size="sm" v-if="option.image" />

        {{ option.label }}

        <IconBase name="cute/check-fill" class="ml-2 -mr-0.5" :width="14" v-if="modelValue.includes(option.value)" />
      </div>

      <div
        class="py-1.5 px-3 rounded-full border border-charcoal-200 dark:border-dark-600 flex items-center font-bold text-sm shrink-0 transition cursor-pointer"
        @click="() => page++"
        key="load-more"
        v-if="optionsVisible.length < options.length"
      >
        <IconBase name="cute/plus-fill" class="mr-1.5 ml-0.5" :width="14" />
        
        {{ $t('actions.showMore') }}
      </div>
    </TransitionGroup>
  </div>
</template>

<script lang="ts" setup>
interface Option {
  label: string
  value: string
  image?: string
}

const props = withDefaults(defineProps<{
  modelValue?: string[]
  options?: Option[]
  per_page?: number
  max?: number
}>(), {
  max: 9999,
  per_page: 9999,
	modelValue: () => [],
  options: () => [],
})

const emit = defineEmits([ 'update:modelValue' ])

const page = ref(0)

const optionsVisible = computed(() => {
  return props.options.slice(0, props.per_page * (page.value + 1))
})

const onSelect = (option: Option) => {
  if (props.modelValue?.includes(option.value)) {
    emit('update:modelValue', props.modelValue.filter(v => v !== option.value))
  } else {
    emit('update:modelValue', [ ...(props.modelValue || []), option.value ].slice(0, props.max))
  }
}
</script>